<template>
  <main>
    <tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="text-green">
                        建議調撥(全單位未訪件)
                    </h4>
                    <form class="form">
                        <div class="form-group row">
                            <label class="col-1 text-right">拜訪月份</label>
                            <div class="col-11">
                                <select class="form-control form-control-inline ml-0" v-model="form.year">
                                    <option
                                    v-for="(year, yearIndex) in yearOpt"
                                    :key="`start-service-year-${yearIndex}`"
                                    :value="year.value">{{year.text}}</option>
                                </select>
                                <span class="text">/</span>
                                <select class="form-control form-control-inline" v-model="form.unableModifyMonth">
                                    <option
                                    v-for="(month, monthIndex) in monthOpt"
                                    :key="`start-service-month-${monthIndex}`"
                                    :value="month.value">{{month.text}}</option>
                                </select>
                                <span class="text">～</span>
                                <select class="form-control form-control-inline" v-model="form.year">
                                    <option
                                    v-for="(year, yearIndex) in yearOpt"
                                    :key="`end-service-year-${yearIndex}`"
                                    :value="year.value">{{year.text}}</option>
                                </select>
                                <span class="text">/</span>
                                <select class="form-control form-control-inline" v-model="form.month">
                                    <option
                                    v-for="(month, monthIndex) in monthOpt"
                                    :key="`end-service-month-${monthIndex}`"
                                    :value="month.value">{{month.text}}</option>
                                </select>
                                <a @click="initSearchData()" class="btn btn-primary mt-0">查詢</a>
                            </div>
                        </div>
                    </form>

                    <div>
                    ● 每年5月起，未訪件由建議調撥改列為強制調撥，如要查詢5月以後的統計資料，請改至『強制調撥統計表』查看。
                    </div>
                    <br>

                    <div class="breadcrumb row" v-if="tableRow && tableRow.length">
                        <label class="col-1 text-right">路徑</label>
                        <div class="col-7">
                            <ul class="breadcrumb-list">
                                <!-- <li :class="{
                                'active': currentLevel == null
                                }">
                                    <a role="button" @click="currentLevel = null">全部</a>
                                </li> -->
                                <li class="bread"
                                :class="{
                                'active': bread.level === currentLevel
                                }"
                                v-for="(bread, i) in breadCrumbs"
                                :key="`bread-${i}`">
                                    <a role="button" @click="currentLevel = bread.level">{{bread.name}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-4 text-right">
                          <a @click="downloadData()" class="btn btn-default">下載本頁資料</a>
                          <a v-if="breadCrumbs[breadCrumbs.length-1].target != 'lev6'" @click.prevent="panelOpen('ceadcdChooseModalOpen')" class="btn btn-default">下載轄下資料</a>
                        </div>
                    </div>

                </div>
                <div class="col-12" :class="{'section-loading': isDataTreeLoading}">
                    <!-- <table class="table datatable insurance-green"  v-if="breadcrumbs.length>=1 && breadcrumbs.map(bred => bred.id).indexOf(currentLevel) == (breadcrumbs.length - 1)">
                        <thead>
                            <tr>
                                <th>業務員姓名</th>
                                <th class="text-right">全部保戶數</th>
                                <th class="text-right">初期全單位未訪保戶數</th>
                                <th class="text-right">占率</th>
                                <th class="text-right">未訪保戶數</th>
                                <th class="text-right">減少未訪保戶數</th>
                                <th class="text-right">減少比例</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow" :key="`row-${rid}`">
                            <td>{{row.name}}</td>
                            <td class="text-right">{{row.allClient | numberFormat}}</td>
                            <td class="text-right">{{row.allFarClient | numberFormat}}</td>
                            <td class="text-right">{{row.allFarClientRate}}%</td>
                            <td class="text-right">{{row.farClient | numberFormat}}</td>
                            <td class="text-right">{{row.decreaseFarClient | numberFormat}}</td>
                            <td class="text-right">{{row.decreaseRate}}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentLevel && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="7">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="7">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="tableRow && tableRow.length">
                            <tr class="bg-white">
                                <th class="text-left">合計</th>
                                <th class="text-right">{{countTotal('allClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('allFarClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('allFarClientRate')}}%</th>
                                <th class="text-right">{{countTotal('farClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('decreaseFarClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('decreaseRate')}}%</th>
                            </tr>
                        </tfoot>
                    </table> -->

                    <table class="table datatable insurance-green">
                        <thead>
                            <tr>
                                <th v-if="breadCrumbs.length < 2">系統別</th>
                                <th v-else-if="breadCrumbs.length==2">區別</th>
                                <th v-else-if="breadCrumbs[breadCrumbs.length-1].target=='lev6'">業務員姓名</th>
                                <th v-else>單位</th>
                                <th v-if="Number(currentLevel) < 4" class="text-right">全部保戶數</th>
                                <th class="text-right">期初全單位未訪保戶數</th>
                                <th v-if="Number(currentLevel) < 4" class="text-right">占率</th>
                                <th class="text-right">未訪保戶數</th>
                                <th class="text-right">減少未訪保戶數</th>
                                <th class="text-right">減少比例</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length">
                          <tr v-for="(row, rid) in tableRow"
                          :key="`row-${rid}`">
                            <td>
                              <a v-if="row.child && breakType != 'lev6'" @click="searchData(row.cedvnm, row.cedvno)" class="link text-underline">{{row.cedvnm}}</a>
                              <span v-else-if="row.child">{{row.cedvnm}}</span>
                              <span v-else>{{row.cedvnm}}</span>
                            </td>
                            <td v-if="Number(currentLevel) < 4" class="text-right">{{row.cust}}</td>
                            <td class="text-right">{{row.z_cust}}</td>
                            <td v-if="Number(currentLevel) < 4" class="text-right">{{row.z_rate1}}%</td>
                            <td class="text-right">{{row.thism}}</td>
                            <td class="text-right">{{row.z_remain}}</td>
                            <td class="text-right">{{row.z_remain_rate1}}%</td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentLevel && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="7">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="7">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <!-- <tfoot v-if="tableRow && tableRow.length">
                            <tr class="bg-white">
                                <th class="text-left">合計</th>
                                <th class="text-right">{{countTotal('allClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('allFarClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('allFarClientRate')}}%</th>
                                <th class="text-right">{{countTotal('farClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('decreaseFarClient') | numberFormat}}</th>
                                <th class="text-right">{{countTotal('decreaseRate')}}%</th>
                            </tr>
                        </tfoot> -->
                    </table>
                   
                    <div v-if="tableRow && tableRow.length">
                        <!-- <ol>
                            <li>保單號碼開頭為0、1、含英文字母及部分9100開頭者，為原專寶專福的服務件，有任何疑問請洽總公司保護<br/>部保費企劃科，(02)27551399#1916</li>
                            <li>如有其他疑問，請洽總公司業務部企劃科，(02)27551399#2032、2039、</li>
                        </ol> -->
                        如有其他疑問，請洽總公司業務部業務企劃科，(02)27551399#{{ contactInfo.contact_tel }}
                    </div>
                </div>

            </div>
        </div>
      </div>
    </div>

    <Ceadcd-Choose-Modal
      :open="ceadcdChooseModalOpen"
      :dis="this.dis"
      @close="panelClose('ceadcdChooseModalOpen')"
      @choose="chooseCeadcd"
    />

  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import TabHeader from '@/desktop/components/manager/TabHeader'
import ConnectDataModal from '@/desktop/components/manager/ConnectData'
import { debuglog } from 'util';
import CeadcdChooseModal from '../manager/condition/components/ceadcdChooseModal'
import { queryStatsBZ, downloadStatsBZ, getContactInfoBySerNo } from '../../../service'

export default {
  name: 'TransferTab61',
  mixins: [commonMixin],
  components: {
    TabHeader, CeadcdChooseModal
  },
  computed: {
    tableRow () {
      this.checkBreadCrumbs()
      return this.dataTree[this.currentLevel - 1]
    }
  },
  data () {
    return {
      connectModalOpen: false,
      ceadcdChooseModalOpen: false,
      order: {
          index: 1,
          asc: true
      },
      form: {
        unableModifyMonth: 1,
        year: '',
        month: ''
      },
      yearOpt: [],
      monthOpt: [],
      isDataTreeLoading: false,
      currentLevel: 0,
      apiTarget: {},
      breadCrumbs: [],
      dataTree: [],
      breakType: '',
      dis: '51',
      contactInfo: []
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    checkBreadCrumbs() {
      if(this.dataTree.length > this.currentLevel) {
        this.breakType = ''
        this.dataTree.length = this.currentLevel
        this.breadCrumbs.length = this.currentLevel
      }
    },
    syncBreadCrumbs() {
      if(this.currentLevel==1) {
        this.breadCrumbs = [{level: 1, target: 'lev1', cedvno: '0', name: '全部'}]
      } else {
        this.breadCrumbs.push(this.apiTarget)
      }
    },
    initSearchData () {
      this.currentLevel = 0
      this.dataTree = []
      this.breadCrumbs = []
      this.searchData()
    },
    searchData (name, cedvno) {
      let target = this.searchTarget(cedvno)
      this.apiTarget = {
        level: this.currentLevel + 1,
        target: target,
        cedvno: cedvno,
        name: name
      }
      this.isDataTreeLoading = true
      queryStatsBZ(this.$store.state.userInfo.id, target, this.form.year, this.form.month, cedvno).then(result => {
        if(result.header && result.header.status == '200') {
          let checkedDatas = result.body['query_statsbz_' + target].map(item => {
            if(item.cedvno == '0') {
              item['child'] = false
              return item
            } else {
              item['child'] = true
              return item
            }
          })
          checkedDatas.sort(this.sortCompareFun())
          this.breakType = target
          this.dataTree.push(checkedDatas)
          this.currentLevel++
          this.syncBreadCrumbs()
        } else {
          if(result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '查詢失敗,請重新操作'})
          }
        }
        this.isDataTreeLoading = false

        //  for 難字更新姓名
        if (target == 'lev6') {
          this.registerHanlink()
        }
      })
    },
    downloadData() {
      let nowBreadCrumb = this.breadCrumbs[this.breadCrumbs.length - 1];
      this.isDataTreeLoading = true;
      downloadStatsBZ(this.$store.state.userInfo.id, nowBreadCrumb.target, this.form.year, this.form.month, nowBreadCrumb.cedvno).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            let fileName;
            switch(nowBreadCrumb.target) {
              case 'lev1':
                fileName = '建議調撥(全單位未訪件)-全部.xlsx';
                break;
              case 'lev2':
              case 'lev3':
              case 'lev44':
              case 'lev51':
              case 'lev54':
              case 'lev6':
                fileName = `建議調撥(全單位未訪件)-${nowBreadCrumb.name}-${new Date().getTime()}.xlsx`;
                break;
              default:
                fileName = '建議調撥(全單位未訪件).xlsx';
            }

            saveAs(result, fileName);
          }

          this.isDataTreeLoading = false;
        });
    },
    chooseCeadcd(val) {
      this.panelClose('ceadcdChooseModalOpen');
     this.downloadData2(val);
    },
    downloadData2(val) {
      let target2 = "lev" + val;
      this.isDataTreeLoading = true;
      downloadStatsBZ(this.$store.state.userInfo.id, target2, this.form.year, this.form.month, 'null').then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            let fileName;
            if(val == '2'){
              fileName = '區部總表.xlsx';
            }else if(val =='3'){
              fileName = '區部轄下通訊處總表.xlsx';
            }else if(val =='4'){
              fileName = '展業轄下展業課.xlsx';
            }else if(val =='5'){
              fileName = '專招轄下推展處.xlsx';
            }else if(val =='6'){
              fileName = '展業轄下展業區.xlsx';
            }

            saveAs(result, fileName);
          }

          this.isDataTreeLoading = false;
        });
    },
    searchTarget(cedvno) {
	
      if(this.breadCrumbs.length == 0) {
        return 'lev1'
      } else {
        let lastTarget = this.breadCrumbs[this.breadCrumbs.length -1].target

        // 權限
        if(lastTarget == 'lev3') {
          if(cedvno[2] == '1') {
            // 專招
            lastTarget += '_1'
          } else {
            // 展業
            lastTarget += '_4'
          }
        }

        switch(lastTarget) {
          case 'lev1':
            return 'lev2'
          case 'lev2':
            return 'lev3'
          case 'lev3_1':
            return 'lev51'
          case 'lev3_4':
            return 'lev44'
          case 'lev44':
            return 'lev54'
          case 'lev54':
            return 'lev6'
          case 'lev51':
            return 'lev6'
          default:
            return 'error'
        }
      }
    },
    sortCompareFun() {
      return function(a, b) {
        if(a['cedvno'] == '0') {return 1}
        if(b['cedvno'] == '0') {return -1}
        let result = (a['cedvno'] < b['cedvno']) ? -1 : (a['cedvno'] > b['cedvno']) ? 1 : 0;
        return result;
      }
    },
    initMonthOpt() {
      for(let i=1; i<13; i++) {
        let selectItem = {
          value: String(i),
          text: `${i}月`
        }
        this.monthOpt.push(selectItem)
      }
      this.form.month = String(new Date().getMonth() +1)
      // this.form.month = '9'  //for test
    },
    initYearOpt() {
      let westYear = new Date().getFullYear()
      for(let i=westYear-20; i<=westYear; i++) {
        let selectItem = {
          value: String(i),
          text: `${i - 1911}年`
        }
        this.yearOpt.push(selectItem)
      }
      this.form.year = String(westYear)
      // this.form.year = '2015'  //for test
    },
    initContactInfo(){
      // 以流水編號查詢企劃單位連絡方式
      getContactInfoBySerNo(this.$store.state.userInfo.id, '11').then(result => {
        if(result && result.header.status == '200' && result.body){
            this.contactInfo  = result.body.lists[0];
        }
      })
    },
  },
  beforeMount () {
    this.initMonthOpt()
    this.initYearOpt()
  },
  mounted () {
    //獲得企劃單位聯絡資訊
    this.initContactInfo()
  }
}
</script>
